const localeToConditionsUrl: {[locale: string]: string} = {
    "fr_FR": `https://docs.travelski.com/legal-docs/CGV-FR-4.24.pdf`,
    "fr_FR_CSE": `https://docs.travelski.com/legal-docs/CGV-FR-4.24.pdf`,
    "nl_NL": `https://docs.travelski.com/legal-docs/CGV-NL-4.24.pdf`,
    "en_US": `https://docs.travelski.com/legal-docs/CGV-UK-2025-06-10.pdf`,
    "nl_NL_CSE": `https://docs.travelski.com/legal-docs/CGV-NL-SkiSchool-2025-06-19.pdf`,
}

export default localeToConditionsUrl